__webpack_require__.p = "https://cdn-everest-diamond.ebanx.com/packs/";